import { HttpClient } from '@adapters/HttpClient';
import { StripePortalResponse, SuscriptionModel } from '../models/Suscription';

export class SuscriptionApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getStripe(): Promise<StripePortalResponse> {
    const response = await this.httpClient.get<StripePortalResponse>(
      '/billing/customer-portal'
    );
    return response;
  }

  async getSuscriptionPaginated(): Promise<{
    suscription: SuscriptionModel[];
    nextPage?: number;
    hasMore: boolean;
    total: number;
  }> {
    // Aquí deberías hacer la llamada real a tu endpoint de suscripciones paginadas
    // Por ahora, simula una respuesta vacía para evitar el error
    return {
      suscription: [],
      nextPage: undefined,
      hasMore: false,
      total: 0,
    };
  }
}
